export type FollowUpsTab = 'follow-ups' | 'requests' | 'network';
export type NetworkView = 'list' | 'map';

export type FollowUpsSearch = {
  tab?: FollowUpsTab;
  view?: NetworkView;
  // The table state keys `readTableSearch` reads. A `validateSearch` strips
  // what it does not return, so they are carried through untouched.
  page?: number;
  q?: string;
  sort?: string;
  order?: 'asc' | 'desc';
  filters?: Record<string, unknown>;
};

export const TABS: readonly FollowUpsTab[] = [
  'follow-ups',
  'requests',
  'network',
];

/**
 * Optional on purpose: the nav links here with no search, and an unknown or
 * absent tab reads as the first. `view` only means something on the network
 * tab, so it is dropped elsewhere rather than left to dangle in the URL.
 */
export function validateFollowUpsSearch(
  raw: Record<string, unknown>,
): FollowUpsSearch {
  const tab = TABS.find((t) => t === raw.tab);
  const out: FollowUpsSearch = {};
  if (tab && tab !== 'follow-ups') out.tab = tab;
  if (tab === 'network' && raw.view === 'map') out.view = 'map';
  const page = Number(raw.page);
  if (Number.isInteger(page) && page >= 1) out.page = page;
  if (typeof raw.q === 'string' && raw.q !== '') out.q = raw.q;
  else if (typeof raw.q === 'number') out.q = String(raw.q);
  if (typeof raw.sort === 'string' && raw.sort !== '') {
    out.sort = raw.sort;
    out.order = raw.order === 'asc' ? 'asc' : 'desc';
  }
  if (
    raw.filters &&
    typeof raw.filters === 'object' &&
    !Array.isArray(raw.filters)
  ) {
    out.filters = raw.filters as Record<string, unknown>;
  }
  return out;
}

export function currentTab(search: FollowUpsSearch): FollowUpsTab {
  return search.tab ?? 'follow-ups';
}
